import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAH0CkV26vHpdkCwVwg7dVkghfFspHkZEY",
  authDomain: "infa-accelerators.firebaseapp.com",
  projectId: "infa-accelerators",
  storageBucket: "infa-accelerators.firebasestorage.app",
  messagingSenderId: "807594002571",
  appId: "1:807594002571:web:079b77ad4156db47366c8e"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Analytics (optional)
export const analytics = getAnalytics(app);

export default app;
